(function (root) {
  'use strict';
  // Limits reflect the available line width and type size; the year has its own rule.
  function limit(field) {
    if (field.key === 'year') return 4;
    var minimumSize = Math.max(field.font === 'script' ? 20 : 12, field.size * .62);
    var capacity = Math.floor((field.width - 12) / (minimumSize * .75 + (field.spacing || 0)));
    return field.maxLength || Math.max(field.value.length, Math.min(field.font === 'script' ? 32 : 64, capacity));
  }
  function validateInput(input, field) {
    var error = input.value.length > input.maxLength ? 'Use no more than ' + input.maxLength + ' characters.' : '';
    if (field.key === 'year' && !/^[0-9]{4}$/.test(input.value)) error = 'Enter a four-digit year, for example 2026.';
    input.setCustomValidity(error);
    return !error;
  }
  function bind(input, field, changed) {
    var helper = document.createElement('span');
    helper.className = 'fp-hc-field-help';
    helper.id = input.id + '-help';
    var hint = document.createElement('span'), counter = document.createElement('span');
    hint.textContent = field.key === 'year' ? 'Four-digit year' : 'Text fits automatically';
    helper.append(hint, counter);
    input.after(helper);
    input.setAttribute('aria-label', field.label);
    input.setAttribute('aria-describedby', helper.id);
    if (field.key === 'year') { input.inputMode = 'numeric'; input.pattern = '[0-9]{4}'; }
    function update() {
      counter.textContent = input.value.length + ' / ' + input.maxLength;
      helper.classList.toggle('is-limit', field.key !== 'year' && input.value.length >= input.maxLength);
      validateInput(input, field);
    }
    // Native maxlength handles typing/paste; also validate programmatic or restored values before ordering.
    input.addEventListener('input', function (event) { if (!event.isComposing) { update(); changed(); } });
    input.addEventListener('compositionend', function () { update(); changed(); });
    update();
  }
  function validate(fields) {
    return Array.from(fields.querySelectorAll('input[data-text-key]')).every(function (input) {
      return validateInput(input, {key: input.dataset.textKey}) && input.checkValidity();
    });
  }
  function fit(svg) {
    var canvasWidth = svg.viewBox.baseVal.width;
    svg.querySelectorAll('[data-text-key]').forEach(function (node) {
      var x = Number(node.getAttribute('x'));
      var half = Math.min(Number(node.dataset.maxWidth) / 2 - 4, x - 14, canvasWidth - 14 - x);
      // Measure ink bounds as well as advance width so calligraphy overhangs stay inside the line.
      for (var attempt = 0; attempt < 8; attempt++) {
        var box = node.getBBox();
        var radius = Math.max(Math.abs(box.x - x), Math.abs(box.x + box.width - x), node.getComputedTextLength() / 2);
        if (!radius || radius <= half) break;
        var size = Number(node.getAttribute('font-size'));
        node.setAttribute('font-size', Math.max(1, size * half / radius * .98));
      }
    });
  }
  root.FoxPrintHolidayText = {limit: limit, bind: bind, validate: validate, fit: fit};
}(window));
